import { NgModule } from '@angular/core';
import { TrPlayerComponent } from './tr-player.component';
import { CommonModule } from '@angular/common';
import { TrPlayerMediaService } from './services/tr-player-media.service';
import { TrPlayerButtonComponent } from './components/tr-player-button.component';
import { TrPlayerProgressBarComponent } from './components/tr-player-progress-bar.component';
import { TrPlayerProgressIndicator } from './components/tr-player-progress-indicator.component';
import { TrPlayerSoundTrackService } from './services/tr-player-soundtrack.service';
import { TrVideoPreviewComponent } from './components/tr-video-preview/tr-video-preview.component';
import { TrPlaylistComponent } from './components/tr-playlist/tr-playlist.component';
import { TrVideoResumeComponent } from './components/tr-video-resume/tr-video-resume.component';
import { TrShareCourseComponent } from './components/tr-share-course/tr-share-course.component';
import { TextUtils } from '../../resources/text.utils';
import { UtilitiesService } from '../../services/utilities.service';
import { TrPlayerSessionManagerService } from './services/tr-player-session-manager.service';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TrSpinnerModule } from '../tr-spinner/tr-spinner.module';

@NgModule({
    declarations: [
        TrPlayerComponent,
        TrPlayerButtonComponent,
        TrPlayerProgressBarComponent,
        TrPlayerProgressIndicator,
        TrVideoPreviewComponent,
        TrPlaylistComponent,
        TrVideoResumeComponent,
        TrShareCourseComponent,
    ],
    imports: [
        CommonModule,
        SvgIconModule,
        TrSpinnerModule,
    ],
    exports: [
        TrPlayerComponent,
        TrVideoPreviewComponent,
        TrPlaylistComponent,
    ],
    providers: [
        TrPlayerMediaService,
        TrPlayerSoundTrackService,
        TextUtils,
        UtilitiesService,
        { provide: 'Window',  useValue: window },
        { provide: 'WindowDocument',  useValue: document },
        TrPlayerSessionManagerService,
    ],
})
export class TrPlayerModule {}
